import React, { useState, useEffect } from 'react';
import '../styles/carousel.css';

import img1 from '../assets/gallery/img1.png';
import img2 from '../assets/gallery/img2.png';
import img3 from '../assets/gallery/img3.png';
import img4 from '../assets/gallery/img4.png';
import img5 from '../assets/gallery/img5.png';

const images = [img1, img2, img3, img4, img5];

const Carousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlay, setIsAutoPlay] = useState(true);

  const goPrev = () => {
    setCurrentIndex(prev => prev === 0 ? images.length - 1 : prev - 1);
  };

  const goNext = () => {
    setCurrentIndex(prev => prev === images.length - 1 ? 0 : prev + 1);
  };

  const handleThumbnailClick = (index) => {
    setCurrentIndex(index);
    setIsAutoPlay(false); // stop autoplay when user clicks thumbnail
  };

  useEffect(() => {
    if (!isAutoPlay) return; // skip interval if autoplay is off

    const interval = setInterval(() => {
      goNext();
    }, 3000);

    return () => clearInterval(interval);
  }, [currentIndex, isAutoPlay]);

  return (
    <div className="carousel-div">
      <div className="carousel-wrapper">
        <button className="outer-arrow left" onClick={goPrev}>‹</button>
        
        <div className="carousel-container">
          <div className="carousel-image">
            <img src={images[currentIndex]} alt={`Slide ${currentIndex}`} />
          </div>
          <div className="carousel-thumbnails">
            {images.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`Thumb ${index}`}
                className={index === currentIndex ? 'active' : ''}
                onClick={() => handleThumbnailClick(index)}
              />
            ))}
          </div>
        </div>

        <button className="outer-arrow right" onClick={goNext}>›</button>
      </div>
    </div>
  );
};

export default Carousel;
